import { createFileRoute } from '@tanstack/react-router'

import { CustomerStyleguide } from '@/styleguide/customer/Styleguide'

export const Route = createFileRoute('/styleguide/customer')({
  component: CustomerStyleguide,
})
